/**
 * Into PDF module integration constants.
 */

export const INTO_MODULE_FIELD_TYPE = {
    INJANG: "injang",
    TEXT: "text",
    CHECKBOX: "checkbox",
    RADIO: "radio",
    DROPDOWN: "dropdown",
    FORMULA: "formula",
    BLACKBOX_MASK: "blackbox-mask",
};

export const INTO_MODULE_GROUP_FIELD_TYPE = [
    INTO_MODULE_FIELD_TYPE.RADIO,
    INTO_MODULE_FIELD_TYPE.CHECKBOX,
];

export const INTO_MODULE_PARTICIPANT_ID = "__user__";
